import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import {
  learnLibraryMyItems,
  libraryMyItemsMyCourses
  // libraryMyItemsMyPolicies
} from "../../../routes/LearningCenterRoutes";
import LinkGroup from "../../../components/Nav/LinkGroup/LinkGroup";
import { useTranslation } from "react-i18next";
import MyCoursesContainer from "../../../containers/LearningCenter/Library/MyItems/MyCoursesContainer";
import { Route, Redirect } from "react-router-dom";

const MyItems = ({ history, location: { pathname } }) => {
  const { t } = useTranslation();
  const [myItemsLinks, setMyItemsLinks] = useState([
    {
      path: libraryMyItemsMyCourses,
      title: t("libraryMyItems.myCoursesTitle"),
      active: false
    }
    //
    // TODO: Uncomment below when my policies view is implemented
    /*  {
      path: libraryMyItemsMyPolicies,
      title: t("libraryMyItems.myPoliciesTitle")
    } */
  ]);

  useEffect(() => {
    const links = myItemsLinks.map(link => ({
      ...link,
      active: link.path === pathname
    }));
    setMyItemsLinks(links);
  }, [pathname]);

  return (
    <Box display="flex" flexDirection="column" flex={1}>
      <LinkGroup links={myItemsLinks} history={history} />
      <Route
        exact
        path={learnLibraryMyItems}
        render={() => <Redirect to={libraryMyItemsMyCourses} />}
      />
      <Route
        exact
        component={MyCoursesContainer}
        path={libraryMyItemsMyCourses}
      />
    </Box>
  );
};

export default MyItems;

MyItems.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any,
  match: PropTypes.any
};
